import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Header({ hideLogin }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);
  const RedirectFullURL = `${process.env.REACT_APP_SSO_RedBase_URL}?clientId=${process.env.REACT_APP_SSO_ClientId}`;

  // Optional: Prevent background scroll when sidebar is open
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isSidebarOpen]);

  return (
    <header id="headsection" className="header-container-wrapper">
      <>
        <div className="main-header d-lg-block d-none">
          <div className="container-wrapper">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-3 logo">
                  <Link to="/">
                    <img
                      src="/assets/images/bajajcapital-logo.png"
                      alt="Logo"
                    />
                  </Link>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-8">
                  <div className="main-nav mega-menu">
                    <ul>
                      <li className="has-children">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="has-children">
                        <Link to="/about">About Us</Link>
                      </li>

                      <li>
                        <a
                          href="https://pos.bajajcapitalinsurance.com/sign_up"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Earn with Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://marketing.bajajcapitalinsurance.com/insurance-learning-space"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Learning Space
                        </a>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      {!hideLogin && (
                        <li>
                          <a
                            href={RedirectFullURL}
                            className="new_login"
                            target="_self"
                            rel="noopener noreferrer"
                          >
                            Login
                            <img src="/assets/images/login.svg" alt="login" />
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Header */}
        <div className="mobile-header d-lg-none">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-7">
                <div className="mobile-logo">
                  <div className="mobile-header-links">
                    <button
                      onClick={openSidebar}
                      className="hamburger-menu btn btn-link p-0 border-0"
                      aria-label="Open Menu"
                    >
                      <img
                        src="/assets/images/icons/menu.svg"
                        alt="Menu"
                        width="18"
                      />
                    </button>
                  </div>
                  <a href="./about.aspx" className="logo">
                    <img
                      src="/assets/images/bajajcapital-logo.png"
                      alt="Logo"
                      width="120"
                    />
                  </a>
                </div>
              </div>
              {!hideLogin && (
                <div className="col-5">
                  <a
                    href={RedirectFullURL}
                    className="new_login"
                    target="_self"
                    rel="noopener noreferrer"
                  >
                    Login
                    <img src="/assets/images/login.svg" alt="login" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Sidebar Menu */}
        <div className={`sidebar-menu ${isSidebarOpen ? "active" : ""}`}>
          <div className="mobile-logo">
            <Link to="/">
              <img
                src="/assets/images/bajajcapital-logo.png"
                alt="Logo"
                width="120"
              />
            </Link>
          </div>

          <div className="overlay" onClick={closeSidebar}>
            <span className="close_btn"></span>
          </div>

          <div className="menu-content">
            <ul id="hammenu" className="main-nav">
              <li className="has-children">
                <a href="./" className="active text-danger">
                  Home
                </a>
              </li>
              <li className="has-children">
                <Link to="/about">About Us</Link>
              </li>
              <li className="has-children">
                <a
                  href="https://pos.bajajcapitalinsurance.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Earn with Us
                </a>
              </li>
              <li>
                <a
                  href="https://marketing.bajajcapitalinsurance.com/insurance-learning-space"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learning Space
                </a>
              </li>
              <li className="has-children">
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>

            {/* Our Services */}
            <div className="col-12 col-md footer-nav">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <a
                    href="https://dev.bajajcapitalinsurance.com/general-insurance/pet/input/customer-details"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pet Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.bajajcapitalinsurance.com/general-insurance/bike/lead-page"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    2 Wheeler Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.bajajcapitalinsurance.com/general-insurance/car/lead-page"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Car Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.bajajcapitalinsurance.com/general-insurance/health/input/basic-details"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Health Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="https://marketing.bajajcapitalinsurance.com/get-term-quote"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Term Life Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="https://renew-all.bajajcapitalinsurance.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    All Renewals
                  </a>
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="col-12 col-md footer-nav">
              <h4>Quick Links</h4>
              <ul>
                <li className="has-children">
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <a
                    href="https://pos.bajajcapitalinsurance.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Earn with Us
                  </a>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Legal Policy */}
            <div className="col-12 col-md footer-nav">
              <h4>Legal Policy</h4>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/term-and-condition">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/disclaimer">Disclaimer</Link>
                </li>
                <li>
                  <Link to="/csr-policy">CSR Policy</Link>
                </li>
                <li>
                  <Link to="/BCIBL-Anti-Fraud-Policy">Anti-Fraud Policy</Link>
                </li>
              </ul>
            </div>

            {/* Social Links */}
            <div className="col-12 col-md">
              <h4>Follow Us</h4>
              <ul className="social-links">
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/bajajcapitalinsurance"
                  >
                    <img
                      src="/assets/images/icons/facebook.svg"
                      alt="Facebook"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://twitter.com/Bajaj_insurance"
                  >
                    <img src="/assets/images/icons/twitter.svg" alt="Twitter" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/bajaj.capital.insurance/"
                  >
                    <img
                      src="/assets/images/icons/instagram.svg"
                      alt="Instagram"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    </header>
  );
}

export default Header;
